<template>

    <div>
        <CreatePingModal
            v-show="pingingMember"
            :modalVisible="pingModalShown"
            v-on:modalHidden="onModalHidden"
            :mentionableUsers="[]"
            :userId="user? user.id: null"
            :prePopulatedMentionedUser="pingModalMentionedUser"
            :maxContentLength="1000"
        />

        <ShareModal
            v-show="sharingMember"
            :modalVisible="shareModalShown"
            :mentionableUsers="[]"
            v-on:modalHidden="onModalHidden"
            :sharedUser="shareModalMentionedUser"
            :userId="user? user.id: null"
        />
        <div class="container mt-8 mx-auto">

        <!-- Start button section -->
        <div class="flex">
            <div class="w-1/3"></div>
            <div class="w-1/3 flex justify-start">
                <p class="-ml-28 md:ml-0 left-0 invisible md:visible sm:w-full"
                   v-if="!user">
                    Login or Register to interact with these Pros, and reload this page. Your information will remain private.
                </p>
                <a
                    v-if="user == null"
                    class="primary-btn rounded-lg px-4 text-white no-underscore"
                    type="button"
                    href="/login"
                    target="_blank"
                >
                    Login/Register
                </a>
            </div>
        </div>
        <!-- End button section -->
        <div class="grid grid-cols-4 gap-x-12 content-wrapper">
            <div
                class="justify-start col-span-3"
            >
                <pros-table :user="user"
                            :pros="displayedPros"
                            :text="search_text"
                            :industries="industries"
                            :industry="industry"
                            :profession="profession"
                            :professions="professions"
                            :with-submit="true"
                            :radius="radius"
                            :filters="filters"
                            :lng="search_location.lng"
                            :lat="search_location.lat"
                            :postal_code="postal_code"
                            :sortOrder="sortOrder"
                            :search_options="searchOptions"
                            :radius_choices="radiusChoices"
                            :initially_premium="premium"
                            v-on:openPingModal="showPingModal"
                            v-on:openShareModal="showShareModal"/>

            </div>
            <div
                class="h-1/2 pt-4 col-span-1"
            >
                <Ad :image="'/img/dashboardAd.png'" />
            </div>
        </div>
        <!-- End content section -->
    </div>
</div>
</template>

<script>
import ProsTable from "./partials/ProsTable.vue";
import CreatePingModal from "../Ping/CreatePingModal.vue";
import ShareModal from "../Organizations/partials/ShareModal.vue";
import Ad from "../Utils/Ad.vue";

export default {
    mounted() {
//        console.log( "filters: " + this.filters);
//        console.log( 'index: pros');
//        console.log( this.pros);
//        console.log( this.displayedPros);
//        console.log( "industry id: " + this.industry_id);
//        console.log( "profession id: " + this.profession_id);
//        console.log( 'end mounted()');
    },
    data() {
        return {
            hours: {},
            pingModalShown: false,
            pingModalMentionedUser: null,
            shareModalShown: false,
            shareModalMentionedUser: null,
            connectedData: this.connected,
            showSuccess: false,
            showError: false,
            pingingMember: false,
            sharingMember: false,
            displayedPros: this.pros,
            industry: this.getIndustry( this.industry_id),
            profession: this.getProfession( this.profession_id),
            organization: null,
            searchOptions: ["text", "industry", "profession", "walkins", "location", "sort"],
            radiusChoices: ["5mi", "10mi", "25mi", "50mi", "200mi", "500mi", "1000mi","5000mi"],
            radius: '50mi',
            sortOrder: ['distance', 'relevance'],
        };
    },
    props: [
        "search_text",
        "industries",
        "professions",
        "industryId",
        "professionId",
        "user",
        "pros",
        "landing",
        "search_location",
        "postal_code",
        "filters",
        "premium",
    ],
    methods: {
        onModalHidden() {
            this.pingingMember = false;
            this.pingModalMentionedUser  = null;
            this.pingModalShown = false;
            this.shareModalShown = false;
        },
        uploadModalClosed() {
            this.uploadModalShown = false;
        },
        showPingModal(member){
            this.pingModalMentionedUser = member;
            this.pingingMember = true;
            this.pingModalShown = true;
        },
        showShareModal( member){
            this.shareModalMentionedUser = member;
            this.sharingMember = true;
            this.shareModalShown = true;
        },
        getIndustry( industry_id){
            for( let i = 0, len = this.industries.length; i < len; ++i){
                if( this.industries[i].id === industry_id) {
                    return this.industries[i];
                }
            }
            return null;
        },
        getProfession( profession_id){
            for( let i = 0, len = this.professions.length; i < len; ++i){
                if( this.professions[i].id === profession_id)
                    return this.professions[i];
            }
            return null;
        },
        reloadFeed(){
//            console.log( 'reloading feed');
//            axios.get(`/search`)
//                .then(response => {
//                    this.displayedPros = response.data;
//                    console.log( 'reload:');
//                    console.log( this.displayedPros);
//                })
//                .catch(error =>{
//                    console.log(error);
//                })
        },
    },
    components: {
        ProsTable,
        CreatePingModal,
        ShareModal,
        Ad,
    },
};
</script>

<style scoped>
.button-row {
    margin-top: -25px;
}

.name-box {
    margin-top: -3rem;
    z-index: -1;
}

.pro-link-button svg {
    margin-top: 2px;
}
</style>
